<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";
import moment from "moment";
import Banners from "@/components/widgets/banners";
import Stat from "@/components/widgets/stat";
import ChartBonus from "@/components/widgets/chart-bonus";
import ChartOrders from "@/components/widgets/chart-orders";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Banners,
    Stat,
    ChartBonus,
    ChartOrders
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    monthlyDeadlineLabel() {
      if (!this.monthlyDateEnd) {
        return "—";
      }
      return moment(this.monthlyDateEnd).format("DD/MM/YYYY");
    }
  },
  data() {
    return {
      month_year: moment().format("MM/YY"),

      monthly: "inactive",
      monthlyDateEnd: "",
      countdown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      monthlyProgress: 0,
      countdownTimer: null,

      total: {
        bonus: "R$ -,--",
        balance: "R$ -,--",
      },

      statData: null,
      wallets: null,

      cart: {
        items: {
          loading: true,
          total: 0,
          list: null
        },
        points: {
          unilevel: 0,
          graduation: 0,
        },
        subtotal: '0.00',
        sale: '0.00',
        shipping: {
          method: '-',
          value: '-',
        },
        total: '0.00'
      },

      referral: {
        sponsored: process.env.VUE_APP_URL_PAINEL + this.$store.state.account.user.username,
      }
    };
  },
  methods: {
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    formatHmsUnit(value, minLength) {
      const n = Math.max(0, parseInt(value, 10) || 0);
      return String(n).padStart(minLength, "0");
    },
    toEndMs(m, raw) {
      if (!m || !m.isValid()) {
        return null;
      }
      const s = String(raw == null ? "" : raw).trim();
      if (s.length <= 10) {
        return m.clone().endOf("day").valueOf();
      }
      return m.valueOf();
    },
    updateMonthlyCountdown() {
      if (!this.monthlyDateEnd) {
        this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        this.monthlyProgress = 0;
        return;
      }
      const end = moment(this.monthlyDateEnd);
      if (!end.isValid()) {
        return;
      }
      const endMs = this.toEndMs(end, this.monthlyDateEnd);
      if (endMs == null) {
        return;
      }
      const now = Date.now();
      const left = Math.max(0, endMs - now);
      this.countdown.days = Math.floor(left / 86400000);
      this.countdown.hours = Math.floor((left % 86400000) / 3600000);
      this.countdown.minutes = Math.floor((left % 3600000) / 60000);
      this.countdown.seconds = Math.floor((left % 60000) / 1000);

      const windowMs = 30 * 24 * 60 * 60 * 1000;
      this.monthlyProgress = Math.min(100, Math.max(0, 100 * (1 - Math.min(1, left / windowMs))));
    },
    getMonthly() {
      api.get("reports/monthly").then((response) => {
        this.stopCountdown();
        this.monthly = response.data.status;
        this.monthlyDateEnd = response.data.date || "";
        this.updateMonthlyCountdown();
        if (this.monthly === "active" && this.monthlyDateEnd) {
          this.countdownTimer = setInterval(() => {
            this.updateMonthlyCountdown();
          }, 1000);
        }
        this.getStatData();
      });
    },
    getTotalBonus() {
      api
        .get('reports/bonus/total')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.bonus = this.$options.filters.currency(response.data.total)
            this.getStatData();
          }
        })
    },
    getTotalBalance() {
      api
        .get('wallet/balance/network')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.balance = this.$options.filters.currency(response.data.balance.available)
            this.getStatData();
          }
        })
    },
    getStatData() {
      this.statData = [
        {
          type: "line",
          title: "Plano",
          value: this.account.user.package.name,
          icon: "bx-package",
          theme: "light"
        },
        {
          type: "line",
          icon: "bx-time-five",
          title: "Status",
          value: this.monthly,
          month: true,
          theme: "light"
        },
        {
          type: "line",
          icon: "bx-dollar",
          title: "Total de Bônus",
          value: this.total.bonus,
          theme: "light"
        },
        {
          type: "line",
          icon: "bx-wallet",
          title: "Saldo Disponível",
          value: this.total.balance,
          theme: "dark"
        }
      ]
    },
    getCart() {
      if (!localStorage.cart) {
        api
          .get('store/cart')
          .then(response => {
            if (response.data.status == 'success') {
              this.setStorage(response.data)
            }
          })
          .catch(error => {
            this.cart.errored = error
          })
      } else {
        this.cart = JSON.parse(localStorage.cart)
      }
    },
    setStorage(data) {
      this.cart.items.total = data.items.total
      this.cart.items.list = data.items.list
      this.cart.subtotal = data.subtotal
      this.cart.sale = data.sale
      this.cart.shipping = data.shipping
      this.cart.total = data.total

      localStorage.cart = JSON.stringify(this.cart)
    },
  },
  mounted() {
    this.getMonthly()
    this.getTotalBonus()
    this.getTotalBalance()
    this.getStatData()
    this.getCart()
  },
  beforeDestroy() {
    this.stopCountdown();
  }
};
</script>

<template>
  <Layout>
    <router-link v-if="cart.items.total > 0" to="/store/cart" class="text-dark">
      <div class="card">
        <div class="card-body bg-soft-warning rounded p-0">
          <div class="d-flex align-items-center">
            <img class="rounded-circle header-profile-user m-2 mx-2" :src="cart.items.list[Object.keys(cart.items.list)[0]].image" width="30px" height="30px">
            <div class="py-3">Você deixou alguns produtos em seu carrinho, clique aqui para finalizar o seu pedido!</div>
          </div>
        </div>
      </div>
    </router-link>

    <Banners></Banners>

    <div class="card">
      <div class="card-body p-1 d-flex justify-content-between align-items-center">
        <div class="mr-2">
          <div class="bg-light rounded p-2">
            <i class="bx bx-link-alt font-size-24 align-middle"></i>
          </div>
        </div>
        <h5 class="flex-fill m-0 align-items-center font-size-16">
          Link de indicação
        </h5>
        <div class="d-flex align-items-center">
          <div class="ml-1">
            <ShareNetwork network="whatsapp" url="" :title="referral.sponsored">
              <div class="bg-light rounded p-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #312F4F;">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263">
                  </path>
                </svg>
              </div>
            </ShareNetwork>
          </div>
          <div class="ml-1">
            <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.sponsored
              " v-on:click="$toast.success('Copiado!');">
              <div class="bg-light rounded p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #312F4F;">
                  <path
                    d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z">
                  </path>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="countdown-skin card border-0 mb-3"
      :class="{
        'countdown-skin--inactive': monthly === 'inactive' || !monthlyDateEnd
      }"
    >
      <div class="countdown-skin__body card-body">
        <div
          class="d-flex flex-wrap justify-content-center align-items-center mb-2"
        >
          <div
            class="d-flex align-items-center flex-wrap"
            style="gap: 0.5rem"
          >
            <b-badge
              v-if="monthly === 'inactive'"
              pill
              variant="secondary"
            >
              Inativo
            </b-badge>
            <span class="countdown-skin__meta text-muted small">
              Ativo até: {{ monthlyDeadlineLabel }}
            </span>
          </div>
        </div>

        <b-progress
          v-if="monthlyDateEnd"
          :value="Number(monthlyProgress)"
          :max="100"
          height="10px"
          class="countdown-skin__progress mb-4 rounded"
        />
        <div
          v-if="monthlyDateEnd"
          class="d-flex flex-wrap align-items-stretch justify-content-center countdown-skin__blocks"
        >
          <div class="countdown-tile text-center">
            <div class="countdown-tile__value text-monospace">
              {{ formatHmsUnit(countdown.days, 2) }}
            </div>
            <div class="countdown-tile__unit">
              Dias
            </div>
          </div>
          <div class="countdown-tile text-center">
            <div class="countdown-tile__value text-monospace">
              {{ formatHmsUnit(countdown.hours, 2) }}
            </div>
            <div class="countdown-tile__unit">
              Horas
            </div>
          </div>
          <div class="countdown-tile text-center">
            <div class="countdown-tile__value text-monospace">
              {{ formatHmsUnit(countdown.minutes, 2) }}
            </div>
            <div class="countdown-tile__unit">
              Minutos
            </div>
          </div>
          <div class="countdown-tile text-center">
            <div class="countdown-tile__value text-monospace">
              {{ formatHmsUnit(countdown.seconds, 2) }}
            </div>
            <div class="countdown-tile__unit">
              Segundos
            </div>
          </div>
        </div>
        <div
          v-else
          class="text-center text-muted small py-2 mb-0"
        >
          Não há data de término (fim de vigência) cadastrada. A contagem regressiva aparecerá quando
          existir prazo vinculado ao plano mensal.
        </div>
        <p
          v-if="monthlyDateEnd && monthly === 'inactive'"
          class="text-center text-muted small mb-0 mt-3"
        >
            O prazo deste ciclo já encerrou. Renove o plano mensal para voltar ao status ativo.
        </p>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of statData" :key="index" class="col-md-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" :month="stat.month" :theme="stat.theme" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Bonificações <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartBonus />
          </div>
        </fieldset>
      </div>
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Pedidos <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartOrders />
          </div>
        </fieldset>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.countdown-skin {
  background: #eceff3;
  overflow: hidden;
}

.countdown-skin__body {
  padding: 1.25rem 1.5rem 1.5rem;
}

.countdown-skin__title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #343a40;
}

.countdown-skin--inactive .countdown-skin__title {
  color: #6c757d;
}

/* Barra: preenchido roxo, fundo cinza (como referência) */
.countdown-skin__progress {
  width: 100%;
  min-height: 10px;
  background-color: #dde1e6;
}

.countdown-skin__progress ::v-deep .progress-bar {
  background-color: #5b4a9e;
  border-radius: 4px;
}

.countdown-skin--inactive .countdown-skin__progress ::v-deep .progress-bar {
  background-color: #8b9095;
}

.countdown-skin__blocks {
  gap: 0.75rem;
}

/* Bloco branco: número em cima, H/M/S embaixo */
.countdown-tile {
  min-width: 3.5rem;
  padding: 0.65rem 0.9rem 0.45rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.countdown-skin--inactive .countdown-tile {
  background: #f1f2f4;
  box-shadow: none;
}

.countdown-tile__value {
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.1;
  color: #5b4a9e;
  letter-spacing: 0.02em;
}

.countdown-skin--inactive .countdown-tile__value {
  color: #7a7f86;
}

.countdown-tile__unit {
  margin-top: 0.2rem;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: #5c6368;
  text-transform: uppercase;
}
</style>